 /* eslint react/prefer-stateless-function: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Grid,
  Header,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import NavBar from '../../components/NavBar';
import BookDashIcons from '../../components/Svgs/BookDash';
import { TRANSLATION_FILES } from '../../constants/translation';

class Dash extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static defaultProps = {
    auth: {
      isAdminBasic: false,
    },
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  modules = [
    {
      name: 'Company Documents',
      description: 'Company documents setup',
      type: 'documents',
      route: '/settings/company_documents/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Projects Settings',
      description: 'Project specification setup',
      type: 'projects',
      route: '/settings/projects/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Project Mapping Settings',
      description: 'Project mapping attribute setup',
      type: 'projects',
      route: '/settings/mappings/projects/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Layouts Settings',
      description: 'Layouts specification setup',
      type: 'spec_layout',
      route: '/settings/layouts/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Units Settings',
      description: 'Units specification setup',
      type: 'spec_unit',
      route: '/settings/units/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Business Units',
      description: 'Manage business units and agency',
      type: 'business_unit',
      route: '/business_units/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Picture Tags',
      description: 'Manage picture tags',
      type: 'pictures',
      route: '/settings/tags/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Currency Settings',
      description: 'Manage currency',
      type: 'currencies',
      route: '/settings/currencies/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    this.props.auth.isAdminBasic && {
      name: 'Print Templates',
      description: 'Manage Booking Print Templates',
      type: 'documents',
      route: '/settings/print_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    this.props.auth.isAdminBasic && {
      name: 'SMS Templates',
      description: 'Manage SMS Templates',
      type: 'documents',
      route: '/settings/sms_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    this.props.auth.isAdminBasic && {
      name: 'Quotation Templates',
      description: 'Manage Quotation Templates',
      type: 'documents',
      route: '/settings/quotation_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    this.props.auth.isAdminBasic && {
      name: 'Price Naming',
      description: 'Manage namings of price',
      type: 'accounting',
      route: '/settings/price_naming/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'User Mapping Settings',
      description: 'User mapping attribute setup',
      type: 'projects',
      route: '/settings/mappings/affiliates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Cancellation Reasons',
      description: 'Manage cancellation reasons',
      type: 'documents',
      route: '/settings/cancellation_reasons/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'System Settings',
      description: 'Manage Settings & Custom Options',
      type: 'settings',
      route: '/settings/system_settings/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
  ];
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Settings')}
        />
        <Grid doubling columns={4} className="dash_grid">
          {
            this.modules
            .filter((module) => {
              if (this.props.auth.isSuperAdmin) {
                return module.isSuperAdmin;
              }
              if (this.props.auth.isHeadquarters) {
                return module.isHeadquarters;
              }
              if (this.props.auth.isDeveloper) {
                return module.isDeveloper;
              }
              return true;
            })
            .map((module, idx) => {
              if (module.type) {
                return (
                  <Grid.Column key={idx}>
                    <Link to={module.route}>
                      <Header textAlign="center" as="h3">
                        <p>
                          <BookDashIcons
                            type={module.type}
                            width="6em"
                            height="6em"
                            backfill="#F8F8F8"
                            iconfill="#00233B"
                          />
                        </p>
                        {t(module.name).toUpperCase()}
                        <Header.Subheader>
                          {t(module.description)}
                        </Header.Subheader>
                      </Header>
                    </Link>
                  </Grid.Column>
                );
              }
              return null;
            })
          }
        </Grid>
      </Container>
    );
  }
}

Dash.contextTypes = {
  store: PropTypes.object,
};

export default withTranslation(TRANSLATION_FILES.screens)(connect(Dash.mapStateToProps)(Dash));




// WEBPACK FOOTER //
// ./src/containers/Settings/Dash.jsx